export default{
    list : [
        { name : '布小蛮杂货铺', sid : 1, clz : 's-1'},
        { name : '张莺莺重工厂', sid : 2, clz : 's-2'},
    ],
    shop_dic : {
        '1' : {
            name : '布小蛮杂货铺',
            discount : '2000减200',

        },
        '2' : {
            name : '张莺莺重工厂', 
            discount : '5000减600',
        },     
    },
    order_dic : {
        '1' : {
            name : '布小蛮杂货铺',
            discount : '2000减200',

        },
        '2' : {
            name : '张莺莺重工厂', 
            discount : '5000减600',
        },
        '9' : {
            name : '超值特购', 
        }          
    },
    discountType : {
        1 : {
            parse : 2000,
            cut : 200
        },
        2 : {
            parse : 5000,
            cut : 600
        },
        0 : {
            parse : 0,
            cut : 0
        },          
    },
    shopOfferType : {
        1 : {
            rate : 0.8,
            max : 2000,
            require : 8000,
        },
    },
    update_time : '2024-02-26',
}